import {
  useEffect, useState,
} from 'react';
import { useSelector } from 'react-redux';

function useMapForVehicle() {

  const allDevices = useSelector(({ telemetry: tel }) => tel.allDevices);

  const [loading, setLoading] = useState(true);
  const [filterDevices, setFilterDevices] = useState(allDevices);

  const getDevices = () => {

    setLoading(false);
    setFilterDevices(allDevices);

  };

  useEffect(() => {

    if (allDevices) {

      getDevices();

    }

  }, [allDevices]);

  return {
    loading, filterDevices,
  };

}

export default useMapForVehicle;
